export enum CopilotSwitchBannerVariantEnum {
    default = 'default',
    card = 'card'
}
